var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Element } from "../../element/element";
import { utilities } from "../../utilities/utilities";
import { NavigationComponent } from "../navigationComponent";
// const generateXmas = () => {
//     if (document.cookie.includes("xmas_closed=true")) {
//         return '';
//     }
//     return $$.util.html`
//         <div class="xmas-container position-absolute start-0 end-0 mx-auto shadow d-flex justify-content-center align-items-center"
//             style="background: linear-gradient(135deg, #D72631, #FF0000, #2A9D37, #7AC943);
//                     color: #fff;
//                     bottom:-50px;
//                     height:40px;
//                     font-family: 'Orbitron', sans-serif !important;
//                     font-size: 1.8rem;
//                     box-shadow:
//                         0 0 15px rgba(255,255,255,0.8),
//                         0 0 25px rgba(219,68,55,0.7),
//                         0 0 40px rgba(255, 223, 0, 0.5),
//                         0 0 60px rgba(0, 128, 0, 0.4);
//                     text-shadow:
//                         2px 2px 5px rgba(0,0,0,0.3),
//                         0 0 10px #FFCC00,
//                         0 0 15px #D72631;
//                     height:50px !important;
//                     letter-spacing: 2px;
//                     overflow: hidden;
//                     animation: shimmer 3s infinite linear;">
//             ${new Element({
//                 composer : {
//                     content : $$.util.html`
//                         <button class="btn rounded-0  border-bottom border-2 shadow-0 bg-transparent h4 px-2 py-0text-white d-flex align-items-center gap-3 justify-content-center"> 
//                             <span class="h4">🎄</span>
//                             <span class="h4 text-white"  style="  font-family: 'Orbitron', sans-serif !important;">FESTIVE OPENING HOURS</span>
//                             <i class="fa-solid fa-chevron-right text-white fa-lg"></i>
//                             <span class="h4">🎁</span>
//                         </button>
//                     `
//                 },
//                 events : {
//                     click : () => {
//                         window.open('https://www.learninglounge.com/social/blog/post/1440718053')
//                     }
//                 }
//             }).render()}
//             ${new Element({
//                 composer : {
//                     content : $$.util.html`
//                         <button class="btn flex-shrink-0 position-absolute shadow-0 rounded-circle p-2 border border-2 d-flex align-items-center justify-content-center text-white" style="right:20px; height:30px; width:30px">
//                             <i class="fa-solid fa-times fa-lg">
//                         </button>
//                     ` 
//                 },
//                 events : {
//                     click : (event) => {
//                         const navbar = event.currentTarget.closest('.xmas-container');
//                         if (navbar) navbar.remove();
//                         document.cookie = "xmas_closed=true; path=/";
//                     }
//                 }
//             }).render()}
//             <div class="snowflakes" aria-hidden="true">
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//                 <div class="snowflake"><div class="inner">❅</div></div>
//             </div>
//         </div>
//     `
// }
var generateBanner = function () {
    if (document.cookie.includes("banner_closed=true")) {
        return '';
    }
    return $$.util.html(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        <div class=\" position-absolute banner-container bg-dark start-0 end-0 mx-auto shadow d-flex justify-content-center align-items-center\"\n            style=\";\n                    color: #fff;\n                    bottom:-50px;\n                    height:40px;\n                    font-family: 'Orbitron', sans-serif !important;\n                    height:50px !important;\n                    letter-spacing: 2px;\n                    overflow: hidden;\n                    animation: shimmer 3s infinite linear;\"\n        >\n                    <i class=\"fa-regular fa-2x fa-exclamation-circle me-2\"></i>We are currently updating our systems. Some features may be temporarily unavailable.\n            \n            ", "\n\n        </div>\n    "], ["\n        <div class=\" position-absolute banner-container bg-dark start-0 end-0 mx-auto shadow d-flex justify-content-center align-items-center\"\n            style=\";\n                    color: #fff;\n                    bottom:-50px;\n                    height:40px;\n                    font-family: 'Orbitron', sans-serif !important;\n                    height:50px !important;\n                    letter-spacing: 2px;\n                    overflow: hidden;\n                    animation: shimmer 3s infinite linear;\"\n        >\n                    <i class=\"fa-regular fa-2x fa-exclamation-circle me-2\"></i>We are currently updating our systems. Some features may be temporarily unavailable.\n            \n            ", "\n\n        </div>\n    "])), new Element({
        composer: {
            content: $$.util.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                        <button class=\"btn flex-shrink-0 position-absolute shadow-0 rounded-circle p-2 border border-2 d-flex align-items-center justify-content-center text-white\" style=\"right:20px; height:30px; width:30px\">\n                            <i class=\"fa-solid fa-times fa-lg\">\n                        </button>\n                    "], ["\n                        <button class=\"btn flex-shrink-0 position-absolute shadow-0 rounded-circle p-2 border border-2 d-flex align-items-center justify-content-center text-white\" style=\"right:20px; height:30px; width:30px\">\n                            <i class=\"fa-solid fa-times fa-lg\">\n                        </button>\n                    "])))
        },
        events: {
            click: function (event) {
                var _a;
                var navbar = (_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.closest('.banner-container');
                if (navbar)
                    navbar.remove();
                document.cookie = "banner_closed=true; path=/";
            }
        }
    }).render());
};
var Navbar = /** @class */ (function (_super) {
    __extends(Navbar, _super);
    function Navbar(args) {
        var _this = _super.call(this, args) || this;
        _this.version = "1.8.0.0";
        return _this;
    }
    Object.defineProperty(Navbar.prototype, "height", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.composer) === null || _a === void 0 ? void 0 : _a.height) !== null && _b !== void 0 ? _b : 56;
        },
        enumerable: false,
        configurable: true
    });
    Navbar.prototype.composeDefault = function () {
    };
    Navbar.prototype.render = function () {
        var _a;
        this.element = utilities.html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n             <nav\n                class=\"position-fixed navbar navbar-lounge rounded-0 top-0 start-0 py-0 end-0 cerberus navbar-expand-md\"\n                style=\"color:", "; background-color:", "; height:", "px; z-index:999999; position:fixed !important;\"\n                id=\"siteNavigation\"\n            >\n                ", "\n            </nav>\n           \n        "], ["\n             <nav\n                class=\"position-fixed navbar navbar-lounge rounded-0 top-0 start-0 py-0 end-0 cerberus navbar-expand-md\"\n                style=\"color:", "; background-color:", "; height:", "px; z-index:999999; position:fixed !important;\"\n                id=\"siteNavigation\"\n            >\n                ", "\n            </nav>\n           \n        "])), this.color, this.bgColor, this.height, ((_a = this === null || this === void 0 ? void 0 : this.composer) === null || _a === void 0 ? void 0 : _a.template)
            ? this.composeTemplate()
            : this.composeDefault());
        return this.element;
    };
    return Navbar;
}(NavigationComponent));
export { Navbar };
var templateObject_1, templateObject_2, templateObject_3;
